import React from "react";
import { Popover, PopoverTrigger, PopoverContent } from "./ui/popover";
import { Info } from "lucide-react";
import { fmtDate } from "../lib/api";

// "Why this number?" — small info icon that pops the LLM excerpt + audit
// metadata (model, confidence, extraction timestamp) for a single field
// like non_accrual_pct or pik_income_pct.
//
// Renders nothing if `excerpt` is empty — keeps cells clean for the rows
// where no LLM evidence exists (manual / sheet / XBRL-only rows).
export default function WhyTooltip({ excerpt, model, confidence, extractedAt, ticker, fieldLabel, testId }) {
  if (!excerpt) return null;
  const conf = (confidence || "").toLowerCase();
  const confCls =
    conf === "high" ? "text-groen-dark"
    : conf === "medium" ? "text-gold-dark"
    : "text-burgundy";
  return (
    <Popover>
      <PopoverTrigger
        data-testid={testId}
        title={`Why this number? · ${fieldLabel}`}
        aria-label={`Why this number for ${fieldLabel}`}
        className="ml-1 inline-flex items-center text-graphite/40 hover:text-paars-dark transition-colors focus:outline-none focus:text-paars-dark"
      >
        <Info className="w-3 h-3" strokeWidth={2.2} />
      </PopoverTrigger>
      <PopoverContent
        align="end"
        sideOffset={6}
        className="w-80 bg-champagne border border-stone rounded-none p-0 shadow-lg"
      >
        <div className="px-4 py-3 border-b border-stone bg-stone/40">
          <div className="text-[9px] tracking-[0.3em] uppercase text-paars-dark font-bold mb-0.5">// {ticker} · WHY THIS NUMBER</div>
          <div className="text-xs font-semibold text-graphite">{fieldLabel}</div>
        </div>
        <div className="px-4 py-3">
          <div className="text-[10px] tracking-[0.2em] uppercase text-graphite/55 font-bold mb-1.5">SOURCE EXCERPT</div>
          <blockquote className="text-xs text-graphite/80 leading-relaxed italic border-l-2 border-paars-dark/40 pl-3">
            {excerpt}
          </blockquote>
        </div>
        <div className="px-4 py-3 border-t border-stone bg-stone/30 grid grid-cols-2 gap-3 text-[10px] font-mono">
          <div>
            <div className="tracking-[0.2em] uppercase text-graphite/55 font-bold">Confidence</div>
            <div className={`mt-0.5 font-semibold tracking-wider uppercase ${confCls}`}>{conf || "—"}</div>
          </div>
          <div>
            <div className="tracking-[0.2em] uppercase text-graphite/55 font-bold">Extracted</div>
            <div className="mt-0.5 text-graphite/80">{extractedAt ? fmtDate(extractedAt) : "—"}</div>
          </div>
          <div className="col-span-2">
            <div className="tracking-[0.2em] uppercase text-graphite/55 font-bold">Model</div>
            <div className="mt-0.5 text-graphite/80 truncate">{model || "—"}</div>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}
